import { AUTH_MODE_WIDGET, getReauthHintMode } from "./reauth-hints";
import { hasDashboardAuthHint } from "./dashboard-auth-hint";
import {
  completeDashboardBridgeRedirectCallback,
  getDashboardBridgeToken,
  isDashboardBridgeConfigured,
  readDashboardBridgeCallbackState,
  startDashboardBridgeRedirectRehydration
} from "./dashboard-bridge";

function isLocalHost(hostname) {
  return /^(localhost|127\.0\.0\.1|0\.0\.0\.0|hubs\.local)$/i.test(hostname) || /\.local$/i.test(hostname);
}

export function canAttemptLocalBridgeRehydration({
  location = typeof window !== "undefined" ? window.location : null,
  storage = typeof localStorage !== "undefined" ? localStorage : null,
  now = Date.now()
} = {}) {
  if (!location || !isDashboardBridgeConfigured()) return false;
  if (!isLocalHost(location.hostname)) return false;
  if (getDashboardBridgeToken()) return false;

  return hasDashboardAuthHint(now) || (storage && getReauthHintMode(storage) === AUTH_MODE_WIDGET);
}

function hasDashboardBridgeRedirectCallback(location = typeof window !== "undefined" ? window.location : null) {
  if (!location) return false;

  const state = new URL(location.href).searchParams.get("state") || "";
  return Boolean(state && readDashboardBridgeCallbackState(state));
}

export async function startLocalBridgeRedirectIfHinted(options = {}) {
  const location = options.location || (typeof window !== "undefined" ? window.location : null);
  if (hasDashboardBridgeRedirectCallback(location) || !canAttemptLocalBridgeRehydration({ ...options, location })) {
    return { status: "skipped" };
  }

  const started = await startDashboardBridgeRedirectRehydration(options.returnTo || location.href);
  return started ? { status: "redirecting" } : { status: "skipped" };
}

export async function completeOrStartLocalBridgeRehydration(options = {}) {
  const completed = await completeDashboardBridgeRedirectCallback();
  if (completed.status !== "idle") {
    return completed;
  }

  if (!canAttemptLocalBridgeRehydration(options)) {
    return { status: "skipped" };
  }

  const started = await startDashboardBridgeRedirectRehydration(window.location.href);
  return started ? { status: "redirecting" } : { status: "skipped" };
}
